import React from "react";
import { createPortal } from "react-dom";
import { Loader as Spinner } from "lucide-react";

/**
 * Global Premium Loader
 * Minimalist design: Just a centered spinner on a blurred backdrop.
 */
const Loader = () => {
  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-gray-900/40 backdrop-blur-xl animate-in fade-in duration-500">
      <div className="relative flex items-center gap-4 bg-white/10 p-6 px-8 rounded-2xl border border-white/20 shadow-2xl">
        {/* Simple elegant spinner */}
        <div className="relative">
          <Spinner 
            className="h-10 w-10 text-white animate-spin transition-all duration-300 relative z-10" 
            strokeWidth={3} 
          />
          {/* Subtle pulse glow behind the spinner */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-blue-500/20 blur-xl rounded-full animate-pulse z-0" />
        </div>

        {/* Loading text */}
        <span className="text-white font-bold text-lg tracking-widest uppercase animate-pulse">
          Loading...
        </span>
      </div>
    </div>,
    document.body
  );
};

export default Loader;
